import store from '@/stores';

/** Reaching these without a session is the point; everything else needs one. */
const PUBLIC_ROUTES = ['login', 'recover-password'];

/** No request, no 401: a screen waiting for the user never trips the interceptor. */
export function requireSession(to) {
  return PUBLIC_ROUTES.includes(to.name) || Boolean(store.state.app.token);
}

/** The user module skips its fetch on the login route: a valid session stalls there. */
export function alreadySignedIn(to) {
  return to.name === 'login' && Boolean(store.state.app.token);
}

/** `/` is the login route itself, not a landing — and a guessed one can be role-blocked. */
export function landingPath() {
  try {
    const stored = JSON.parse(localStorage.getItem('menu'))?.default;
    if (typeof stored !== 'string' || stored === '/') return null;

    return stored;
  } catch {
    return null;
  }
}
